import { addDays } from "@/utils/common/date";

export default class GradePCPRequestModel {
    dataInicial = new Date();
    dataFinal: Date = addDays(5, new Date());
    formasFarmaceuticasIds: Array<number> = [];
    tipoVendas: Array<number> = [];
    setorId: number = null;
    capacidadeId?: number = null;
    dataSelecionada? = new Date();
    isPendente?: boolean;
    somenteNoHorarioDaFaixa = false;
}
